import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "isHeader", "title"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import TableCell from './TableCell';
import TableRowHeader from './TableRowHeader';
import { jsx as _jsx } from "react/jsx-runtime";
var TableBodyCell = function TableBodyCell(_ref) {
  var children = _ref.children,
    isHeader = _ref.isHeader,
    title = _ref.title,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  if (isHeader) {
    return /*#__PURE__*/_jsx(TableRowHeader, _objectSpread(_objectSpread({}, otherProps), {}, {
      children: children
    }));
  }
  return /*#__PURE__*/_jsx(TableCell, _objectSpread(_objectSpread({}, otherProps), {}, {
    "data-columnheader": title,
    children: children
  }));
};
TableBodyCell.displayName = 'TableBodyCell';
export default TableBodyCell;